export const firebaseConfig = {
  apiKey: 'AIzaSyACv5ETuj0K7nPhaZDkxUqxpGHz3ZmPFf4',
  authDomain: 'identila-platform.firebaseapp.com',
  projectId: 'identila-platform',
  storageBucket: 'identila-platform.firebasestorage.app',
  messagingSenderId: '250224983847',
  appId: '1:250224983847:web:64684c23eecf09b6c67302',
  measurementId: 'G-WK0747YW0L',
} as const;
